import account from "./EN-US/account.json";
import aiDiagnose from "./EN-US/aiDiagnose.json";
import allCarManage from "./EN-US/allCarManage.json";
import base from "./EN-US/base.json";
import bookingManagement from "./EN-US/bookingManagement.json";
import common from "./EN-US/common.json";
import contractManagement from "./EN-US/contractManagement.json";
import dataManage from "./EN-US/dataManage.json";
import home from "./EN-US/home.json";
import homeMap from "./EN-US/homeMap.json";
import index from "./EN-US/index.json";
import menu from "./EN-US/menu.json";
import moveCarManage from "./EN-US/moveCarManage.json";
import newCommon from "./EN-US/newCommon.json";
import orderManage from "./EN-US/orderManage.json";
import ordersManage from "./EN-US/ordersManage.json";
import paper from "./EN-US/paper.json";
import purchase from "./EN-US/purchase.json";
import sale from "./EN-US/sale.json";
import settings from "./EN-US/settings.json";
import shopOrder from "./EN-US/shopOrder.json";
import shopping from "./EN-US/shopping.json";
import statistics from "./EN-US/statistics.json";
import statisticsIndex from "./EN-US/statisticsIndex.json";
import storeManagement from "./EN-US/storeManagement.json";
import tdms from "./EN-US/tdms.json";
import teamManage from "./EN-US/teamManage.json";
import quickBilling from "./EN-US/quickBilling.json";
import components from "./EN-US/components.json";
import erpcomponents from "./EN-US/erpcomponents.json";
import stock from "./EN-US/stock.json";
import orgManage from "./EN-US/orgManage.json";
import customerManage from "./EN-US/customerManage.json"
import dataDictionaries from "./EN-US/dataDictionaries.json"
import login from "./EN-US/Login.json"
import logs from "./EN-US/logs.json"
import permission from "./EN-US/permission.json"



const enUS = {
  translation: {
    permission,
    logs,
    login,
    account,
    aiDiagnose,
    allCarManage,
    base,
    bookingManagement,
    common,
    contractManagement,
    dataManage,
    home,
    homeMap,
    index,
    menu,
    moveCarManage,
    newCommon,
    orderManage,
    ordersManage,
    paper,
    purchase,
    sale,
    settings,
    shopOrder,
    shopping,
    statistics,
    statisticsIndex,
    storeManagement,
    tdms,
    teamManage,
    quickBilling,
    components,
    erpcomponents,
    stock,
    orgManage,
    customerManage,
    dataDictionaries
  }
};

export default enUS;
